import React, { memo, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Scrollbars from 'react-custom-scrollbars';

import { isMl3App, isiOS } from '../modules/DeviceOptions';
import {
  getMl3AppVersion,
  NativeGetGFList,
  NativeSetGF
} from '../modules/Native';
import { versionCompare } from '../modules/Utils';

let initialized = false;

const initGeoFenceSettings = async () => {
  if (isMl3App && isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.1.1') < 0) {
      return;
    }

    // show buttons
    $('.geoFenceSettings').show();

    $(document).on('click', '.openGeoFenceSettingsModal', e => {
      e.preventDefault();

      if (!initialized) {
        ReactDOM.render(
          <GeoFenceSettingsModalComponent />,
          document.getElementById('GeoFenceSettingsModal')
        );

        initialized = true;
      }

      window.openModal('#GeoFenceSettingsModal');
    });

    const GeoFenceSettingsModalComponent = memo(() => {
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(false);
      const [list, setList] = useState([]);

      useEffect(() => {
        NativeGetGFList()
          .then(gfList => {
            setList(gfList);
            setLoading(false);
          })
          .catch(() => setError(true));
      }, []);

      return (
        <div className="modalInner">
          <div className="modalHead">
            <p>{window.resolveLang('情報配信')}</p>
            <i className="closeModal" />
          </div>
          <div className="modalBody">
            <Scrollbars autoHide style={{ height: '100%' }}>
              <div className="geoFenceSettingsList">
                {(() =>
                  list.map(({ title, ads_area_id, enabled }, index) => {
                    return (
                      <div className="gfsListItem" key={ads_area_id}>
                        <p>
                          {title} - {ads_area_id}
                        </p>
                        <div
                          className={enabled ? 'enabled' : ''}
                          onClick={() => {
                            const newList = [...list];
                            newList[index].enabled = !enabled;
                            setList(newList);

                            NativeSetGF(ads_area_id, !enabled);
                          }}
                        >
                          <i />
                        </div>
                      </div>
                    );
                  }))()}

                {loading && !error && (
                  <div className="skLoadingContainer">
                    <div className="sk-fading-circle">
                      <div className="sk-circle1 sk-circle" />
                      <div className="sk-circle2 sk-circle" />
                      <div className="sk-circle3 sk-circle" />
                      <div className="sk-circle4 sk-circle" />
                      <div className="sk-circle5 sk-circle" />
                      <div className="sk-circle6 sk-circle" />
                      <div className="sk-circle7 sk-circle" />
                      <div className="sk-circle8 sk-circle" />
                      <div className="sk-circle9 sk-circle" />
                      <div className="sk-circle10 sk-circle" />
                      <div className="sk-circle11 sk-circle" />
                      <div className="sk-circle12 sk-circle" />
                    </div>
                  </div>
                )}

                {!loading && !list.length && (
                  <p>{window.resolveLang('情報がありません')}</p>
                )}

                {error && <p>{window.resolveLang('エラーが発生しました。')}</p>}
              </div>
            </Scrollbars>
          </div>
        </div>
      );
    });
  }
};

initGeoFenceSettings();
